'use client';

import { useAtomRefresh, useAtomValue } from '@effect/atom-react';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';

import { glossaryTermsPerPage } from '@vs-shop/engine/config/glossary';

import { GlossaryEmptyState } from './GlossaryEmptyState';
import { GlossaryLoadError } from './GlossaryLoadError';
import { GlossarySkeletonGrid } from './GlossarySkeletonGrid';
import { GlossaryFavoritesGrid } from '../../../server/page/glossary/GlossaryFavoritesGrid';

import { fetchGlossaryTermsAtom } from '../../../../effect/atom/glossary/fetchGlossaryTerms';
import { GlossaryMode } from '../../../../effect/data/glossary/glossaryMode';

export function GlossaryFavoritesView() {
  const favoritesAtom = fetchGlossaryTermsAtom(null, null, true, 1, glossaryTermsPerPage);
  const response = useAtomValue(favoritesAtom);
  const retry = useAtomRefresh(favoritesAtom);

  return AsyncResult.match(response, {
    onInitial: () => <GlossarySkeletonGrid />,
    onFailure: () => <GlossaryLoadError onRetry={retry} />,
    onSuccess: ({ value }) => {
      const terms = value['hydra:member'];
      if (terms.length === 0) return <GlossaryEmptyState mode={GlossaryMode.favorites} />;
      return <GlossaryFavoritesGrid terms={terms} />;
    },
  });
}
